module.exports = __webpack_public_path__ + "img/weixin.babf0f52.jpg";